import { render, staticRenderFns } from "./FinancesProjectSpecialisationForm.vue?vue&type=template&id=2abf72c4"
import script from "./FinancesProjectSpecialisationForm.vue?vue&type=script&lang=js"
export * from "./FinancesProjectSpecialisationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports